import { render, staticRenderFns } from "./basicReportTable.vue?vue&type=template&id=49176c28&scoped=true"
import script from "./basicReportTable.vue?vue&type=script&lang=js"
export * from "./basicReportTable.vue?vue&type=script&lang=js"
import style0 from "./basicReportTable.vue?vue&type=style&index=0&id=49176c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49176c28",
  null
  
)

export default component.exports